export { BugsnagLoggerOptions } from './loggers/logBugsnag';
export { default, init, LogLevel } from './logger';



// WEBPACK FOOTER //
// ./packages/platform-utils/logging/index.ts